import { MarkdownRenderer } from '../../AIMessageBlock/MarkdownRenderer';
import { DataTableRenderer } from '../../AIMessageBlock/DataTableRenderer';
import { RecordCardRenderer } from '../../AIMessageBlock/RecordCardRenderer';
import { ChartRenderer } from '../../AIMessageBlock/ChartRenderer';
import { ErrorRenderer } from '../../AIMessageBlock/ErrorRenderer';
import { ConfirmationRenderer } from '../../AIMessageBlock/ConfirmationRenderer';
import { ToolProgressRenderer } from '../../AIMessageBlock/ToolProgressRenderer';
import { CodeRenderer } from '../../AIMessageBlock/CodeRenderer';
import { DeepLinkRenderer } from '../../AIMessageBlock/DeepLinkRenderer';
import { DeflectionRenderer } from '../../AIMessageBlock/DeflectionRenderer';
import { CalloutRenderer } from '../../AIMessageBlock/CalloutRenderer';
import { AgentBadgeRenderer } from '../../AIMessageBlock/AgentBadgeRenderer';
import { MetricRenderer } from '../../AIMessageBlock/MetricRenderer';
import { CitationRenderer } from '../../AIMessageBlock/CitationRenderer';
import { DisclaimerRenderer } from '../../AIMessageBlock/DisclaimerRenderer';
import { LoadingRenderer } from '../../AIMessageBlock/LoadingRenderer';
import { TimeoutRenderer } from '../../AIMessageBlock/TimeoutRenderer';
import { QuerySourceRenderer } from '../../AIMessageBlock/QuerySourceRenderer';
import { RecordListRenderer } from '../../AIMessageBlock/RecordListRenderer';
import { PartialFailureRenderer } from '../../AIMessageBlock/PartialFailureRenderer';
import { ProgressRenderer } from '../../AIMessageBlock/ProgressRenderer';
import { FileDownloadRenderer } from '../../AIMessageBlock/FileDownloadRenderer';
import { AgentTransitionRenderer } from '../../AIMessageBlock/AgentTransitionRenderer';
import { ConversationalFormRenderer } from '../../AIMessageBlock/ConversationalFormRenderer';
import { ExecutionPlanRenderer } from '../../AIMessageBlock/ExecutionPlanRenderer';
import { PlanProgressRenderer } from '../../AIMessageBlock/PlanProgressRenderer';
import { UsageMetricRenderer } from '../../AIMessageBlock/UsageMetricRenderer';
import { SourceDocumentsRenderer } from '../../AIMessageBlock/SourceDocumentsRenderer';
import { SourceCitationRenderer } from '../../AIMessageBlock/SourceCitationRenderer';
import { ResolutionConfirmationRenderer } from '../../AIMessageBlock/ResolutionConfirmationRenderer';
import { ZendeskTicketRenderer } from '../../AIMessageBlock/ZendeskTicketRenderer';
import { SupportHandoffOfferRenderer } from '../../AIMessageBlock/SupportHandoffOfferRenderer';
import { DayBriefRenderer } from '../../AIMessageBlock/DayBriefRenderer';
/**
 * Block renderer registry — maps ContentBlockType → React component.
 * Unregistered block types are silently skipped by AIAgentMessage.
 */
const blockRegistry = {
    markdown: MarkdownRenderer,
    data_table: DataTableRenderer,
    record_card: RecordCardRenderer,
    chart: ChartRenderer,
    error: ErrorRenderer,
    confirmation: ConfirmationRenderer,
    file_download: FileDownloadRenderer,
    tool_progress: ToolProgressRenderer,
    code: CodeRenderer,
    deep_link: DeepLinkRenderer,
    deflection: DeflectionRenderer,
    callout: CalloutRenderer,
    agent_badge: AgentBadgeRenderer,
    metric: MetricRenderer,
    citation: CitationRenderer,
    disclaimer: DisclaimerRenderer,
    loading: LoadingRenderer,
    timeout: TimeoutRenderer,
    query_source: QuerySourceRenderer,
    record_list: RecordListRenderer,
    partial_failure: PartialFailureRenderer,
    progress: ProgressRenderer,
    agent_transition: AgentTransitionRenderer,
    conversational_form: ConversationalFormRenderer,
    execution_plan: ExecutionPlanRenderer,
    plan_progress: PlanProgressRenderer,
    usage_metric: UsageMetricRenderer,
    source_documents: SourceDocumentsRenderer,
    // Support Agent (ipa-support-agent V1 + human live-chat continuation)
    source_citation: SourceCitationRenderer,
    resolution_confirmation: ResolutionConfirmationRenderer,
    zendesk_ticket: ZendeskTicketRenderer,
    support_handoff_offer: SupportHandoffOfferRenderer,
    // Field Assistant day brief (ipa-tech-first-run-day-brief)
    day_brief: DayBriefRenderer
};
export function getBlockRenderer(type) {
    return blockRegistry[type];
}
export { blockRegistry };
